import { render, staticRenderFns } from "./SylvanaEntering.vue?vue&type=template&id=898a1b68&"
import script from "./SylvanaEntering.vue?vue&type=script&lang=ts&"
export * from "./SylvanaEntering.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports